import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["figuresAmended"];

  reportAmendedChanged(event) {
    if (event.target.value === "true") {
      this.figuresAmendedTarget.classList.remove("hidden");
      this.setFiguresRequired(true);
    } else {
      this.figuresAmendedTarget.classList.add("hidden");
      this.setFiguresRequired(false);
      this.clearFiguresSelection();
    }
  }

  setFiguresRequired(required) {
    this.figuresAmendedTarget.querySelectorAll("input[type=radio]").forEach((radio) => {
      radio.required = required;
    });
  }

  clearFiguresSelection() {
    this.figuresAmendedTarget.querySelectorAll("input[type=radio]").forEach((radio) => {
      radio.checked = false;
    });
  }
}
